import { cx } from "@emotion/css";
import { MouseEvent, useState } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createRateInputStyles } from "./createRateInputStyles";
import { ReactComponent as StarIcon } from "./star.svg";

type RateInputProps = {
  onChange: (e: MouseEvent<HTMLElement>, rate: number) => void;
  className?: string;
  currentRating: number;
};

export const RateInput = ({
  onChange,
  className,
  currentRating,
}: RateInputProps) => {
  const [rating, setRating] = useState(0);
  const classes = createRateInputStyles(useTheme());

  const handleStarClick = (e: MouseEvent<HTMLElement>, rate: number) => {
    setRating(rate);
    onChange(e, rate);
  };
  return (
    <div className={cx(classes.root, className)}>
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            key={index}
            onClick={(e) => handleStarClick(e, index)}
            className={classes.starButton}
          >
            <StarIcon
              className={cx(classes.starIcon, {
                [classes.active]: index <= (rating ? rating : currentRating),
              })}
            />
          </button>
        );
      })}
    </div>
  );
};
